import { AxiosError } from 'axios'
import { SnackbarOptions } from 'contexts/SnackbarContext'

export interface ErrorResponse {
  message?: string
  detail?: string
  statusCode?: number
  title?: string
  status?: number
  instance?: string
  id?: string
  code?: string
  severity?: number
}

export interface ErrorHandlerFunction {
  error?: AxiosError<ErrorResponse>
  serverErrorMessage?: string
  customErrorMessage?: string
  showAlert: (options: SnackbarOptions) => void
  intercept?: number
}

const ERROR_MESSAGES = {
  SERVER_ERROR: 'Erro no servidor ao tentar realizar a operação, tente novamente mais tarde.',
  GATEWAY_TIMEOUT: 'Limite de tempo excedido, tente novamente mais tarde.',
  UNAUTHORIZED:
    'Erro de autorização na sessão, você será redirecionado para fazer o login novamente',
  FORBIDDEN: 'Você não tem permissão para realizar esta ação',
  DEFAULT: 'Erro ao realizar a operação, tente novamente mais tarde.'
} as const

type ErrorHandlerType = {
  [key: number]: (errorResponse?: string) => {
    message: string
    statusType: 'message' | 'error' | 'success'
    redirect?: boolean
  } | null
}

const ERROR_HANDLERS: ErrorHandlerType = {
  400: (errorResponse?: string) => {
    if (errorResponse === 'Usuário da sessão incompátivel IDS0001') {
      return {
        message: ERROR_MESSAGES.UNAUTHORIZED,
        statusType: 'error',
        redirect: true
      }
    }
    return null
  },
  401: () => ({
    message: ERROR_MESSAGES.UNAUTHORIZED,
    statusType: 'error',
    redirect: true
  }),
  403: () => ({
    message: ERROR_MESSAGES.FORBIDDEN,
    statusType: 'error'
  }),
  500: () => ({
    message: ERROR_MESSAGES.SERVER_ERROR,
    statusType: 'error'
  }),
  504: () => ({
    message: ERROR_MESSAGES.GATEWAY_TIMEOUT,
    statusType: 'error'
  })
} as const

export const HandlerErrorMessage = ({
  error,
  customErrorMessage,
  showAlert,
  intercept
}: ErrorHandlerFunction) => {
  const handleError = (status: number, errorResponse?: string) => {
    if (customErrorMessage) {
      return false
    }

    const handler = ERROR_HANDLERS[status]
    const result = handler?.(errorResponse)

    if (result) {
      showAlert({
        message: result.message,
        statusType: result.statusType,
        duration: 5000
      })

      if (result.redirect) {
        setTimeout(() => {
          window.location.href = '/'
        }, 3000)
      }
      return true
    }
    return false
  }

  if (intercept) {
    if (!handleError(intercept)) {
      showAlert({
        message: customErrorMessage ?? ERROR_MESSAGES.DEFAULT,
        statusType: 'error',
        duration: 5000
      })
    }
    return
  }

  const errorStatus = error?.response?.status
  const errorMessage = error?.message
  const errorResponse = error?.response?.data?.detail

  if (error && ((errorStatus && errorStatus === 500) || (!errorStatus && !errorMessage))) {
    handleError(500)
  } else if (errorStatus && handleError(errorStatus, errorResponse)) {
    return
  } else {
    showAlert({
      message: customErrorMessage ?? errorResponse ?? ERROR_MESSAGES.DEFAULT,
      statusType: 'error',
      duration: 5000
    })
  }
}
